import { __decorate } from "tslib";
import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';
import { removeDuplicates } from '@/helpers/base';
let CalendarStore = class CalendarStore extends VuexModule {
    post_code_availabilities = [];
    post_code = '';
    country_iso = '';
    usersList = [];
    calendar_view_data = null;
    user_on_calendar = false;
    setUserList(technicians) {
        const userList = technicians.map(item => ({
            name: item.full_name || 'Unknown',
            pro_title: item.pro_title,
            color: item.color,
            id: item.id,
            appointment_count: item.appointment_count,
        }));
        this.usersList = removeDuplicates(userList, 'id');
    }
    setAvailabilitiesToStore(availabilities) {
        this.post_code_availabilities = availabilities;
    }
    setUserOnCalendar(value) {
        this.user_on_calendar = value;
    }
    clearCalendarState() {
        this.post_code_availabilities = [];
        this.post_code = '';
        this.usersList = [];
        this.calendar_view_data = null;
    }
    addEventToStore(event) {
        this.post_code_availabilities.push(event);
    }
    setCalendarViewData(calendar_view_data) {
        this.calendar_view_data = calendar_view_data;
    }
    actionAvailabilitiesToStore(data) {
        this.context.commit('setAvailabilitiesToStore', data.availabilities);
        if (data.setUsers && data.isBookingEventType && data.technicians) {
            this.context.commit('setUserList', data.technicians);
        }
    }
    setPostCode(post_code) {
        this.post_code = post_code;
    }
    setCountryIso(country_iso) {
        this.country_iso = country_iso;
    }
};
__decorate([
    Mutation
], CalendarStore.prototype, "setUserList", null);
__decorate([
    Mutation
], CalendarStore.prototype, "setAvailabilitiesToStore", null);
__decorate([
    Mutation
], CalendarStore.prototype, "setUserOnCalendar", null);
__decorate([
    Mutation
], CalendarStore.prototype, "clearCalendarState", null);
__decorate([
    Mutation
], CalendarStore.prototype, "addEventToStore", null);
__decorate([
    Mutation
], CalendarStore.prototype, "setCalendarViewData", null);
__decorate([
    Action
], CalendarStore.prototype, "actionAvailabilitiesToStore", null);
__decorate([
    Mutation
], CalendarStore.prototype, "setPostCode", null);
__decorate([
    Mutation
], CalendarStore.prototype, "setCountryIso", null);
CalendarStore = __decorate([
    Module({ namespaced: true })
], CalendarStore);
export default CalendarStore;
